import { authorizedRequest, unAuthorizedRequest } from "../utils/axios";
import { API_ENDPOINT } from "./endpoint";

export type ERCType = "ERC1155" | "ERC721";

export interface PinnedNFTInfo {
  id: string;
  contract: string;
  tokenId: string;
  chainId: number;
  balance: number;
  ercType: ERCType;
  name?: string;
  ownerAddress?: string;
  uri?: string;
  title?: string;
  desc?: string;
  dataType?: any;
  externalUrl?: string;
  rawImage?: string;
  animationUrl?: string;
  rawAnimation?: string;
  imageUrl?: string;
  symbol?: string;
  lastSyncAt?: string;
}

export interface PinnedMultiNFTRequest {
  nfts: PinnedNFTInfo[];
}

export interface PinnedMetaNFT {
  id?: string;
  owner_id?: string;
}

export interface PinnedNFTsResponse {
  id?: string;
  owner_id?: string;
  nfts: PinnedNFTInfo[];
}

export const pinNFTApi = {
  getListPinnedNFTsOfUser: async (
    address: string
  ): Promise<PinnedNFTsResponse> =>
    await authorizedRequest.get(`${API_ENDPOINT.USER}/${address}/pinned_nfts`),

  getListPinnedNFTsOfPublicUser: async (
    address: string
  ): Promise<PinnedNFTsResponse> =>
    await unAuthorizedRequest.get(
      `${API_ENDPOINT.PUBLIC_USER}/${address}/pinned_nfts`
    ),

  pinSingleNFT: async (body: PinnedNFTInfo): Promise<PinnedNFTsResponse> =>
    await authorizedRequest.post(
      `${API_ENDPOINT.USER}/pinned_following_nft`,
      body
    ),

  createPinMultiNFT: async (
    body: PinnedMultiNFTRequest
  ): Promise<PinnedNFTsResponse> =>
    await authorizedRequest.post(`${API_ENDPOINT.USER}/pinned_nfts`, body),

  updatePinMultiNFT: async (
    id: string,
    body: PinnedMultiNFTRequest
  ): Promise<PinnedNFTsResponse> =>
    await authorizedRequest.patch(
      `${API_ENDPOINT.USER}/pinned_nfts/${id}`,
      body
    ),

  unPinSingleNFT: async (body: PinnedNFTInfo): Promise<PinnedNFTsResponse> =>
    await authorizedRequest.delete(`${API_ENDPOINT.USER}/pinned_nft`, {
      data: body,
    }),
};
